module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corvus/crv_dir-3d01ba326d3048457a2911c689909511.gif";